import type { CreateConnectorFn } from '@particle-network/connector-core';
import { injected } from './injected';

export const defaultConnectorFns = (): CreateConnectorFn[] => {
  const connectors: CreateConnectorFn[] = [];

  connectors.push(injected({ target: 'phantom' }));
  connectors.push(injected({ target: 'coinbaseWallet' }));
  connectors.push(injected({ target: 'okxWallet' }));
  connectors.push(injected({ target: 'bitKeep' }));
  connectors.push(injected({ target: 'trustWallet' }));

  return connectors;
};
